import { render, staticRenderFns } from "./BookStats.vue?vue&type=template&id=0091a5ab&"
import script from "./BookStats.vue?vue&type=script&lang=js&"
export * from "./BookStats.vue?vue&type=script&lang=js&"
import style0 from "./BookStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports